module.exports = __webpack_public_path__ + "static/media/detalles.cbfc4b3c.png";